<template>
    <div class="flex grow flex-col items-center justify-center px-4 py-8">
        <TasksEmptyImage class="h-64 object-contain object-bottom" />
        <Markdown lang-key="tasks.empty" class="mt-4 text-center text-lg font-light tracking-wide text-gray-700" />
    </div>
</template>
